import logo from './logo.svg';
import './App.css';
import UrlZip from './components/UrlZip/UrlZip';

function App() {
  document.title='URLZip : Zip lengthy URLs';
  return (
    <UrlZip/>
  );
}

export default App;
